import { render, staticRenderFns } from "./additional-products.vue?vue&type=template&id=5e4e377b&"
import script from "./additional-products.vue?vue&type=script&lang=js&"
export * from "./additional-products.vue?vue&type=script&lang=js&"
import style0 from "./additional-products.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports